"use client";

import { useEffect, useState } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CheckCircle2, Loader2 } from "lucide-react";

export function ReaderPricingEffects() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const redirectTarget = "/browse";

  useEffect(() => {
    if (searchParams.get("success") !== "true") return;
    setOpen(true);

    const timer = setInterval(() => {
      setCountdown((prev) => (prev <= 0 ? 0 : prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [searchParams]);

  useEffect(() => {
    if (searchParams.get("success") !== "true") return;
    if (countdown === 0) {
      router.push(redirectTarget);
    }
  }, [countdown, router, redirectTarget, searchParams]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent showCloseButton={false} className="sm:max-w-md text-center max-w-[calc(100%-2rem)] mx-auto">
        <DialogHeader>
          <div className="mx-auto mt-2 mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30">
            <CheckCircle2 className="h-8 w-8 text-green-600 dark:text-green-500" />
          </div>
          <DialogTitle className="text-2xl font-bold tracking-tight mb-2 flex justify-center">Subscription Successful!</DialogTitle>
          <DialogDescription className="text-base text-center">
            You are now a SuperReader. Enjoy unlimited listening on stories with audio enabled.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center py-4">
          <Loader2 className="h-6 w-6 animate-spin text-primary mb-4" />
          <p className="text-sm text-muted-foreground">Returning you to {redirectTarget}... in {countdown} seconds</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
